<template>
    <div>
        <ynav title="请选择生产企业"></ynav>
        <div class="ym_list">
            <ul>
                 <li v-for="item in producerList" @click="pick(item)" :key="item">
                     {{ item }}
                 </li>
            </ul>
        </div>
    </div>
</template>

<script>
import * as api from "../libs/api";
import  ynav from "../components/nav";

export default {
  components: {
    ynav
  },
  data() {
    return {
        producerList:[]
    };
  },
  methods: {
    init()
    {
        if(this.$store.state.name)
        {
             api.getProducerList({name:this.$store.state.name}).then(res=>{
                 if(res.status==200&&res.data.status=='Ok')
                 {
                     this.producerList=res.data.results.List;
                 }
                 else
                 {
                     alert("加载数据异常~");
                 }
             });
        }
        else
        {
           this.$router.push({ name: "Index" });
        }
    },
    pick(value) {
        this.$store.commit("pushProducer", value);
        this.$router.push({ name: "Index" });
    }
  },

  mounted() {
      this.init();
  }
};
</script>




// WEBPACK FOOTER //
// src/views/SelectProducer.vue